document.addEventListener("DOMContentLoaded", () => {
  const buttonHTML = `
<button class="video-pause-play" aria-label="Play video" id="video-pause-play" tabindex="0">
    <span class="play-btn">
        <svg width="27" height="31" viewBox="0 0 27 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_11735_24205)">
                <path d="M3.11562 1.01505L24.1307 13.1132L3.14584 25.2637L3.11562 1.01505Z" fill="white"></path>
            </g>
            <defs>
                <filter id="filter0_d_11735_24205" x="0.315723" y="0.215015" width="26.6149" height="29.8488" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                    <feOffset dy="2"></feOffset>
                    <feGaussianBlur stdDeviation="1.4"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11735_24205"></feBlend>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11735_24205" result="shape"></feBlend>
                </filter>
            </defs>
        </svg>
    </span>
    <span class="pause-btn hidden">
        <svg width="35" height="38" viewBox="0 0 35 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_11735_24363)">
                <path d="M7 4H14V28H7V4ZM21 4H28V28H21V4Z" fill="white"></path>
            </g>
            <defs>
                <filter id="filter0_d_11735_24363" x="0.9" y="0.9" width="33.2" height="36.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                    <feOffset dy="3"></feOffset>
                    <feGaussianBlur stdDeviation="3.05"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11735_24363"></feBlend>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11735_24363" result="shape"></feBlend>
                </filter>
            </defs>
        </svg>
    </span>
</button>`;


  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = buttonHTML;
  const baseButton = tempDiv.firstElementChild;
  const processedParents = new WeakSet();

  document.querySelectorAll(".CSP_slider video").forEach((video, index) => {
    const parent = video.parentNode;
    if (processedParents.has(parent)) return;

    const videosInParent = parent.querySelectorAll("video");
    if (!videosInParent.length) return;

    // Ensure all videos have unique IDs
    videosInParent.forEach((v, i) => {
      if (!v.id) v.id = `video-${index}-${i}`;
    });

    // Clone and insert button
    const clonedButton = baseButton.cloneNode(true);
    
    // Ensure button is properly accessible
    clonedButton.setAttribute("tabindex", "0");
    clonedButton.setAttribute("role", "button");
    clonedButton.setAttribute("type", "button");
    
    // Add additional accessibility attributes
    clonedButton.setAttribute("aria-pressed", "false");
    clonedButton.style.cursor = "pointer";
    clonedButton.style.outline = "none"; // Remove default outline but ensure focus is visible
    
    

    // Find the slide link by looking up the DOM tree from the video embed
    const slideLink = parent.closest('.swiper-slide')?.querySelector('.ss-slide-link');
    if (slideLink) {
      // Insert button after the slide link closes
      slideLink.parentNode.insertBefore(clonedButton, slideLink.nextSibling);
    } else {
      // No slide link found, insert button at the end of the slide
      const slideElement = parent.closest('.swiper-slide');
      if (slideElement) {
        slideElement.appendChild(clonedButton);
      } else {
        parent.appendChild(clonedButton);
      }
    }

    const playIcon = clonedButton.querySelector(".play-btn");
    const pauseIcon = clonedButton.querySelector(".pause-btn");

    // Toggle icons based on video state
    videosInParent.forEach((v) => {
      v.addEventListener("play", () => {
        pauseIcon.classList.remove("hidden");
        playIcon.classList.add("hidden");
      });

      v.addEventListener("pause", () => {
        playIcon.classList.remove("hidden");
        pauseIcon.classList.add("hidden");
      });

      // Also toggle play/pause on click of the video itself
      v.addEventListener("click", () => {
        if (v.paused) {
          videosInParent.forEach((vid) => vid.pause());
          v.play();
          clonedButton.setAttribute("aria-label", "Pause video");
        } else {
          v.pause();
          clonedButton.setAttribute("aria-label", "Play video");
        }
      });
    });

    // Click handler for button
    const handleButtonAction = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Find the first visible video in parent
      let visibleVideo = null;
      for (const v of videosInParent) {
        const rect = v.getBoundingClientRect();
        const isVisible =
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0;
        if (isVisible) {
          visibleVideo = v;
          break;
        }
      }

      // Fallback to first video if none detected
      if (!visibleVideo) visibleVideo = videosInParent[0];

      if (visibleVideo.paused) {
        videosInParent.forEach((vid) => vid.pause()); // pause all others
        visibleVideo.play();
        clonedButton.setAttribute("aria-label", "Pause video");
      } else {
        visibleVideo.pause();
        clonedButton.setAttribute("aria-label", "Play video");
      }
    };

    // Click handler for button (this should handle both mouse clicks and keyboard Enter/Space)
    clonedButton.addEventListener("click", handleButtonAction);
    
    // Keyboard handler for accessibility
    clonedButton.addEventListener("keydown", (e) => {
      if (e.code === "Enter" || e.code === "Space") {
        e.preventDefault();
        handleButtonAction(e);
      }
    });
    
    // Add focus styles for accessibility
    clonedButton.addEventListener("focus", (e) => {
      clonedButton.style.outline = "2px solid #007cba";
    });
    
    // Remove focus styles when button loses focus
    clonedButton.addEventListener("blur", (e) => {
      clonedButton.style.outline = "none";
    });

    processedParents.add(parent);
  });
});
